<template lang='pug'>
#modal-visualizar-detalhes-alerta
    el-dialog.custom-dialog(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='85%',
        v-loading='isLoading'
    )
        template(slot='title')
            div.dialog-header
                | {{ $t('mensagens.diagnosticoSocioambiental.diagnosticoEmLote') }}
            p
                | {{ $t('mensagens.diagnosticoSocioambiental.inserirArquivoXls') }}
        div.body
            div.import-container
                p.sub-title
                    | {{ $t('mensagens.diagnosticoSocioambiental.importarArquivo') }}
                div.import-content
                    p.sub-title-content
                        el-icon.warning-alert-color(:class="'el-icon-warning'")
                        | {{ $t('mensagens.diagnosticoSocioambiental.atencao') }}
                    p
                        | {{ $t('mensagens.diagnosticoSocioambiental.certifiqueQueAsInformacoesEstaoCorretas') }}
                    el-upload.upload-demo(
                        :file-list='fileList',
                        drag,
                        action='alert',
                        :auto-upload='false',
                        :on-change='onLoadFile',
                        :on-remove='onRemoveFile',
                        :on-exceed='onLimitExceed',
                        :limit='1',
                        ref='upload'
                    )
                        i.el-icon-upload(style='margin-top: 40px')
                        .el-upload__text {{ $t('mensagens.diagnosticoSocioambiental.uploadFile.1') }} <em class='custom-em'>{{ $t('mensagens.diagnosticoSocioambiental.uploadFile.2') }}</em>
                        p {{ $t('mensagens.diagnosticoSocioambiental.arquivoNoFormatoXls') }}
            div.result-container
                p.sub-title
                    | {{ $t('mensagens.diagnosticoSocioambiental.resultadoDiagnostico') }}
                div.result-content
                    el-table.sizing-overflow(:data="tableData", border)
                        el-table-column(:label="$t('mensagens.diagnosticoSocioambiental.carDocumento')", prop="CAR/Documento", :formatter='formatTableData')
                        el-table-column(:label="$t('mensagens.diagnosticoSocioambiental.analiseSocioambiental')", prop="Análise Socioambiental", align='center', width='210')
                            template(scope="scope")
                                div.loading-container
                                    el-icon.loading.processing(
                                        v-if="scope.row['Análise Socioambiental'] === 'Processando...'",
                                        slot='icon',
                                        class='el el-icon-loading')
                                    span(v-if="scope.row['Análise Socioambiental'] === 'Processando...'",)
                                        | {{ scope.row['Análise Socioambiental'] }}
                                    el-icon.loading.high(
                                        v-if="scope.row['Análise Socioambiental'] === 'Inconforme'",
                                        slot='icon',
                                        class='mdi mdi-alert-outline')
                                    el-icon.loading.medium(
                                        v-if="scope.row['Análise Socioambiental'] === 'Com alerta'",
                                        slot='icon',
                                        class='mdi mdi-alert-outline')
                                    el-icon.loading.success(
                                        v-if="scope.row['Análise Socioambiental'] === 'Conforme'",
                                        slot='icon',
                                        class='mdi mdi-check-circle-outline')
                                    el-icon.loading.failed(
                                        v-if="scope.row['Análise Socioambiental'] === 'Não encontrado'",
                                        slot='icon',
                                        class='mdi mdi-close-circle-outline')
                    div.footer-container
                        p.sub-title-footer
                            | {{ $t('mensagens.diagnosticoSocioambiental.legenda') }}:
                        div.sub-text-footer
                            div
                                span.success(class='mdi mdi-check-circle-outline')
                                | {{ $t('mensagens.diagnosticoSocioambiental.conforme') }}
                            div
                                span.medium(class='mdi mdi-alert-outline')
                                | {{ $t('mensagens.diagnosticoSocioambiental.comAlerta') }}
                            div
                                span.high(class='mdi mdi-alert-outline')
                                | {{ $t('mensagens.diagnosticoSocioambiental.inconforme') }}
                            div
                                span.failed(class='mdi mdi-close-circle-outline')
                                | {{ $t('mensagens.diagnosticoSocioambiental.documentoNaoEncontrado') }}
        el-divider.custom-divider
        footer.footer-content(slot='footer')
            BaseButton.margin-top(@click='fecharModal()', size='big', type='outline')
                | {{ $t('mensagens.comuns.voltar') }}
            BaseButton.margin-top(@click='exportToExcel()', :disabled='!canExport', size='big', type='primary', icon='el-icon-download')
                | {{ $t('mensagens.diagnosticoSocioambiental.exportarResultadoAnalise') }}
        </template>

<script>
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import formatters from '@/utils/formatters';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import DiagnosticoLoteItauMixin from '@/mixins/DiagnosticoLoteItauMixin';

export default {
    name: 'ModalDiagnosticoSociambientalEmLote',

    components: {
        BaseButton
    },

    props: {
        show: {
            type: Boolean,
            required: true
        },
        tableData: {
            type: Array,
            required: false
        },
        exportTable: {
            type: Array,
            required: false
        },
        protocolo: {
            type: String,
            required: false
        }
    },

    mixins: [DiagnosticoLoteItauMixin],

    data() {
        return {
            isLoading: false,
            fileList: [],
            percentage: 0,
            listaDeDocumentos: [],
            canExport: false
        };
    },

    methods: {
        fecharModal() {
            this.$emit('voltar');
        },

        onLimitExceed() {
            this.$notify.warning({
                message: this.$t('mensagens.diagnosticoSocioambiental.somenteUmArquivoPorVez')
            });
        },

        onRemoveFile() {
            this.fileList = [];
        },

        onLoadFile(file) {
            if (this.mxIsItau()) {
                this.mxOnLoadFileItau(file);
            } else {
                if (this.validateFileFormat(file)) {
                const reader = new FileReader();
                this.canExport = false;
                reader.onload = async (e) => {
                    let hasValidInfo = false;
                    const arrayBuffer = e.target.result;
                    const data = new Uint8Array(arrayBuffer);
                    const workbook = XLSX.read(data, { type: 'array' });

                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];

                    const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1, blankrows: false });

                    const headerRow = jsonData[0];
                    const carCpfCnpjIndex = headerRow.findIndex(column => column === 'CAR/CPF/CNPJ');

                    if (carCpfCnpjIndex === -1 || jsonData.length <= 1) {
                        this.showWarningMessage();
                        return;
                    }

                    const carCpfCnpjArray = jsonData.slice(1, 101).map(row => {
                        const value = row[carCpfCnpjIndex].toString().replace(/[^\w\s]/g, '');

                        if (/^\d{11}$/.test(value) || /^\d{14}$/.test(value) || /^[A-Z]{2}\d{7}.+$/.test(value)) {
                            hasValidInfo = true;
                        }

                        return value;
                    });

                    if (!hasValidInfo) {
                        this.showWarningMessage();
                        return;
                    }

                    this.tableData = carCpfCnpjArray.map(item => ({
                        'CAR/Documento': item,
                        'Análise Socioambiental': this.$t('mensagens.diagnosticoSocioambiental.processando')
                    }));

                    this.exportTable = carCpfCnpjArray.map(item => ({
                        'CAR/Documento': item
                    }));

                    for (let i = 0; i < carCpfCnpjArray.length; i++) {
                        this.canExport = false;
                        const item = carCpfCnpjArray[i];
                        let hasAlto = false;
                        let hasMedio = false;
                        let hasBaixo = false;

                        if (/^[A-Z]{2}\d{7}.+$/.test(item)) {
                            try {
                                let dataCAR = null;
                                let diagnosticos = null;
                                const response = await DiagnosticoSocioambientalService.consultar('CODIGOCAR', this.formatCAR(item), true, false, null, this.protocolo);

                                if (response.data) {
                                    dataCAR = response.data.dataCAR[0];
                                    if (dataCAR) {
                                        diagnosticos = dataCAR.diagnosticos;
                                    }
                                }

                                diagnosticos.forEach((diagnostico) => {
                                    const columnName = diagnostico.camada.nome;
                                    this.exportTable[i][columnName] = diagnostico.nivelAlerta;
                                });

                                for (const diagnostico of diagnosticos) {
                                    const priority = diagnostico.nivelAlerta;

                                    if (priority === 'ALTO') {
                                        hasAlto = true;
                                    } else if (priority === 'MEDIO') {
                                        hasMedio = true;
                                    } else if (priority === 'BAIXO') {
                                        hasBaixo = true;
                                    }
                                }

                                const analysisResult = this.determineAnalysisResult(hasAlto, hasMedio, hasBaixo);
                                this.tableData[i]['Análise Socioambiental'] = analysisResult;
                            } catch (error) {
                                this.tableData[i]['Análise Socioambiental'] = this.$t('mensagens.diagnosticoSocioambiental.naoEncontrado');
                            }
                        } else if (/^\d{11}$/.test(item) || /^\d{14}$/.test(item)) {
                            try {
                                let dataCAR = null;
                                const response = await DiagnosticoSocioambientalService.consultar('CPF_CNPJ', item, true, false, null, this.protocolo);

                                if (response.data) {
                                    dataCAR = response.data.dataCAR;
                                }

                                dataCAR.forEach((diagnostico) => {
                                    const columnName = diagnostico.camada.nome;
                                    this.exportTable[i][columnName] = diagnostico.nivelAlerta;
                                });

                                for (const carItem of dataCAR) {
                                    const priority = carItem.nivelAlerta;

                                    if (priority === 'ALTO') {
                                        hasAlto = true;
                                    } else if (priority === 'MEDIO') {
                                        hasMedio = true;
                                    } else if (priority === 'BAIXO') {
                                        hasBaixo = true;
                                    }
                                }

                                const analysisResult = this.determineAnalysisResult(hasAlto, hasMedio, hasBaixo);
                                this.tableData[i]['Análise Socioambiental'] = analysisResult;
                            } catch (error) {
                                this.tableData[i]['Análise Socioambiental'] = this.$t('mensagens.diagnosticoSocioambiental.naoEncontrado');
                            }
                        } else {
                            this.tableData[i]['Análise Socioambiental'] = this.$t('mensagens.diagnosticoSocioambiental.naoEncontrado');
                        }
                    }
                    this.canExport = true;
                };

                reader.readAsArrayBuffer(file.raw);
            }
            }
        },

        determineAnalysisResult(hasAlto, hasMedio, hasBaixo) {
            if (hasAlto) {
                return this.$t('mensagens.diagnosticoSocioambiental.inconforme');
            } else if (hasMedio) {
                return this.$t('mensagens.diagnosticoSocioambiental.comAlerta');
            } else if (hasBaixo) {
                return this.$t('mensagens.diagnosticoSocioambiental.conforme');
            } else {
                return this.$t('mensagens.diagnosticoSocioambiental.naoEncontrado');
            }
        },

        showWarningMessage() {
            this.onRemoveFile();
            this.$notify.warning({
                message: this.$t('mensagens.diagnosticoSocioambiental.erro.arquivoInvalido')
            });
        },

        formatTableData(row, column, data, index) {
            if (/^\d{11}$/.test(data) || /^\d{14}$/.test(data)) {
                return formatters.numeralStringFormatToDocumento(data);
            } else if (/^[A-Z]{2}\d{7}.+$/.test(data)) {
                return formatters.formatCar(data);
            } else {
                return data;
            }
        },

        formatCAR(item) {
            return formatters.formatCar(item);
        },

        validateFileFormat(file) {
            const validExtensions = ['.xls', '.xlsx'];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.'));

            if (validExtensions.includes(fileExtension)) {
                return true;
            } else {
                this.onRemoveFile();
                this.$notify.error(this.$t('mensagens.diagnosticoSocioambiental.somenteArquivosXlsSaoPermitidos'));
                return false;
            }
        },

        exportToExcel() {
            if (this.mxIsItau()) {
                this.mxExportToExcelItau();
            } else {
                const filename = 'diagnostico-socioambiental-lote.xlsx';
                const headers = this.getUniqueCamadaHeaders(this.exportTable);

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');

                const headersRow = [
                    [' - ', ' - ', this.$t('mensagens.diagnosticoSocioambiental.criticidadeDeAcordoComProtocolo')],
                    [this.$t('mensagens.diagnosticoSocioambiental.itemAnalisado'), this.$t('mensagens.diagnosticoSocioambiental.resultado'), ...headers]
                ];

                worksheet.addRows(headersRow);

                worksheet.getRow(1).eachCell(cell => {
                    cell.font = { bold: true };
                });
                worksheet.getRow(2).eachCell(cell => {
                    cell.font = { bold: true };
                });

                const columnWidths = [
                    { width: 50 },
                    { width: 20 },
                    { width: 40 },
                    ...Array.from({ length: headers.length }, () => ({ width: 25 }))
                ];
                worksheet.columns = columnWidths;

                for (const row of this.exportTable) {
                    const formattedData = this.formatTableData(row, 'CAR/Documento', row['CAR/Documento']);

                    const rowData = [
                        formattedData,
                        this.determineMaxNivelAlerta(row),
                        ...this.extractCamadaValues(row, headers)
                    ];

                    const newRow = worksheet.addRow(rowData);

                    newRow.getCell(1).font = { bold: false };
                }

                workbook.xlsx.writeBuffer().then(buffer => {
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                });
            }
        },

        getUniqueCamadaHeaders(data) {
            const headersSet = new Set();
            for (const row of data) {
                for (const key in row) {
                    if (!key.startsWith('CAR/')) {
                        headersSet.add(key);
                    }
                }
            }
            return [...headersSet];
        },

        determineMaxNivelAlerta(row) {
            const levelsPriority = ['ALTO', 'MEDIO', 'BAIXO'];
            for (const level of levelsPriority) {
                for (const key in row) {
                    if (row[key] === level) return this.determineMaxAlert(level);
                }
            }
            return this.$t('mensagens.diagnosticoSocioambiental.naoEncontradoResultadoIndisponivel');
        },

        determineMaxAlert(str) {
            if (str === 'ALTO') {
                return this.$t('mensagens.diagnosticoSocioambiental.inconforme');
            } else if (str === 'MEDIO') {
                return this.$t('mensagens.diagnosticoSocioambiental.comAlerta');
            } else {
                return this.$t('mensagens.diagnosticoSocioambiental.conforme');
            }
        },

        extractCamadaValues(row, headers) {
            const hasNivelAlerta = headers.some(header => row[header]);

            if (!hasNivelAlerta) {
                return headers.map(() =>
                    ' - '
                );
            }

            return headers.map(header => {
                return row[header] ? this.determineMaxAlert(row[header]) : ' - ';
            });
        }

    }
};
</script>

<style lang='scss' scoped>
#modal-visualizar-detalhes-alerta {

    ::v-deep .el-dialog__body {
        padding: 0px;
    }

    .sizing-overflow {
        height: 360px;
        overflow-y: auto;
    }

    .loading {
        margin-right: 5px;
    }

    .processing {
        font-size: 15px;
    }

    .high {
        color: rgba(236, 50, 50, 1);
        font-size: 20px;
    }

    .failed {
        color: rgba(116, 15, 15, 1);
        font-size: 20px;
    }

    .success {
        color: rgba(53, 145, 56, 1);
        font-size: 20px;
        margin-left: 5px;
    }

    .medium {
        color: rgba(254, 197, 86, 1);
        font-size: 20px;
        overflow-wrap: break-word !important;
    }

    .body {
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
        height: auto;
        display: flex;
        justify-content: space-between;
    }

    .el-upload__text {
        font-size: 16px;
    }

    .warning-alert-color {
        margin-right: 5px;
        color: rgba(221, 172, 68, 1) !important;
    }

    .custom-em {
        color: rgba(39, 111, 218, 1) !important;
    }

    .sub-text-footer {
        font-size: 14px;
        display: grid;
        grid-template-columns: repeat(3, .8fr) 2fr;
        place-items: center;
        white-space: nowrap;

        div:not(:last-child) {
            padding-right: 20px;
        }

        div:is(:last-child) {
            padding-left: 10px;
        }

        div:not(:first-child) {
            border-left: 1px solid rgba(0, 0, 0, 0.322);
            padding-left: 20px;
        }

        div {
            display: flex;
            align-items: center;

            span {
                padding-right: 3px;
            }
        }
    }

    .sub-title-content {
        font-family: Roboto;
        font-size: 14px;
        color: #000000;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
    }

    .sub-title-footer {
        font-family: Roboto;
        font-size: 14px;
        color: #00413c;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
        margin-left: 10px;
    }

    .import-container {
        width: 38%;
        height: 500px;
    }

    .import-content {
        width: 100%;
        padding: 15px;
        height: 90%;
        border: 1px solid rgba(117, 117, 117, 0.247);
        border-radius: 5px;
    }

    .result-container {
        width: 61%;
        height: 500px;
    }

    .result-content {
        width: 100%;
        height: 90%;
        border: 1px solid rgba(117, 117, 117, 0.247);
        border-radius: 5px;
    }

    .footer-content {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }

    .custom-divider {
        margin-bottom: -10px;
        margin-top: 5px;
    }

    .content {
        overflow: auto;
        max-height: 250px;
    }

    .margin-top {
        margin-top: 16px;
    }

    .margin-left {
        margin-left: 20px;
    }

    .custom-cursor {
        cursor: pointer;
    }

    .alert-container {
        line-height: 1rem;
    }

    .alert-footer {
        display: flex;
    }

    .footer-label {
        font-family: 'Roboto', 'sans serif';
        color: #00413c;
        font-weight: 500;
        margin-right: 5px;
        font-size: 13.5px;
    }

    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        border-color: blue !important;
        background-color: blue !important;
    }

    .el-radio-button__orig-radio:checked+.el-radio-button__inner::after {
        border-color: blue !important;
        background-color: blue !important;
    }

    .custom-expanded-table {
        margin-top: -20px;
    }

    .custom-icon {
        margin-right: 9px;
        vertical-align: middle;
        filter: brightness(0) invert(1);
    }

    .radio-group-container {
        max-width: 510px;
        height: 10px;
        display: flex;
        justify-content: space-between;
    }

    .custom-buttom:hover .custom-icon {
        filter: none;
    }

    .lyra-icon {
        cursor: pointer;
    }

    .menu-description {
        font-weight: 400;
        font-size: 16px;
        font-family: 'Roboto', 'sans serif';
    }

    .radio-spacing {
        margin-right: 10px;
    }

    .dialog-header {
        background-color: #e9e9e9;
        color: #00413c;
        padding: 15px;
        margin: -20px -20px 20px -20px;
        font-size: 18px;
        font-weight: 600;
        border-radius: 5px, 5px, 0px, 0px;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
    }

    .custom-dialog {
        border-radius: 5px;
    }

    footer {
        display: flex;
        justify-content: flex-end;
    }

    .c-pagination {
        text-align: center;
        margin-top: 30px;
    }

    .view-title {
        margin-left: 15px;
        font-family: 'Roboto', 'sans serif';
        font-size: 16px;
        font-weight: 500;
    }

    .sub-title {
        font-family: 'Roboto', 'sans serif';
        font-weight: 500;
        color: #000000;
    }

    .alert-title {
        font-family: 'Roboto', 'sans serif';
        color: #00413c;
        font-weight: 500;
        margin-top: 35px;
    }

    .alert-description {
        font-family: 'Roboto', 'sans serif';
        color: #000000;
        font-weight: 300;
    }

    .el-table {
        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon>.el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            line-height: 18.75px;
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }

        .el-descriptions-item__label.has-colon::after {
            content: '';
        }
    }
}
</style>
